import { Outlet } from "react-router-dom";

const PatientFileLayout: React.FC = () => {
    
  return (
      <Outlet />
  );
};

export default PatientFileLayout;
